import { render, staticRenderFns } from "./content.vue?vue&type=template&id=ebc0f0e8&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=ebc0f0e8&prod&scoped=true&lang=less"
import style1 from "./content.vue?vue&type=style&index=1&id=ebc0f0e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc0f0e8",
  null
  
)

export default component.exports